import { MUITab } from "@abb/arcadia-ui-react"
import { useContext } from "react"
import { DiMaProgress } from "../../components/DiMaProgress"
import { UserContext } from "../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToFeature,
} from "../../models/Authorization"
import { useHashTab } from "../../../hooks/useHashTab"
import { AccessRequests } from "./users_tab/AccessRequests"
import { Users } from "./users_tab/Users"

export function UsersContainer() {
  const { user } = useContext(UserContext)
  const { activeTab, handleTabChange } = useHashTab("users")

  const userHasBackofficeReadAccess = hasUserAccessToFeature(
    user?.authorizations ?? { applications: [], features: [] },
    DimaFeatureShortNameEnum.BA,
    AccessLevel.Read
  )

  if (!user) {
    return <DiMaProgress />
  }

  return (
    <div>
      <MUITab
        tabItems={[
          { id: "users", label: "Users" },
          {
            id: "accessRequest",
            label: "Access Requests",
            isDisabled: !userHasBackofficeReadAccess,
          },
        ]}
        value={activeTab}
        handleChange={handleTabChange}
      />

      {activeTab === "users" && <Users />}
      {userHasBackofficeReadAccess && activeTab === "accessRequest" && <AccessRequests />}
    </div>
  )
}
